import React, { useState } from 'react';
import BarCode from './BarCode/BarCode';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartShopping, faFileLines } from '@fortawesome/free-solid-svg-icons';
import { currencies } from 'utils/enums/marketplace';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { addToCartAction } from 'store/actions/cart.actions';
import { setQuantityToolbar } from 'store/slices/cart.slice';
import { useAppDispatch } from 'utils/hooks/redux';

import { RootState } from 'store/store';
import { IAddToCartParams } from 'models/car-parts.model';
import QuantityInput from 'components/inputs/QuantityInput/QuantityInput';
import Disponibility from 'components/disponibility/Disponibility';
import CarPartPrice from 'components/CarPartPrice/CarPartPrice';
import IconButton from 'components/buttons/IconButton/IconButton';
import Spinner from 'components/spinner/Spinner';
import { useDeviceDetect } from 'utils/hooks/deviceDetect';
import { getCurrentMarketplace, notify } from 'utils/marketplace';
import { Marketplaces } from 'utils/constants/applications';
import './ConsumableOptions.scss';
import CirrusDisponibility from 'components/CirrusDisponibility/CirrusDisponibility';
import useHttp from 'utils/hooks/useHttp';
import { isRetailerMecadepotChild } from 'utils/isRetailerMecadepotChild';

type Props = {
  consumable;
};

const ConsumableOptions: React.FC<Props> = (props) => {
  const consumable = props.consumable;
  const [quantityValue, setQuantityValue] = useState<number>(consumable?.available?.uv || 1);
  const [addToCartButtonLoading, setAddToCartButtonLoading] = useState(false);
  const { quantityToolbar } = useSelector((state: RootState) => state.cart);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { isMobile } = useDeviceDetect();
  const currentMarketplace = getCurrentMarketplace();
  const [disableCartBtn, setDisableCartBtn] = useState(false);
  const [contactLoading, setContactLoading] = useState(false);
  const http = useHttp();
  const user = JSON.parse(localStorage.getItem('userData')!);
  const isMecadepotChild = isRetailerMecadepotChild();
  const [isInternalclient, setIsInternalclient] = useState(false);

  const handleAddToCart = () => {
    if (!quantityValue) {
      return;
    }


    console.log(getPrice());

    setAddToCartButtonLoading(true);

    const params: IAddToCartParams[] = [];

    let param: IAddToCartParams = {
      consumable_id: consumable.consumable_id,
      quantity: quantityValue,
      price: getPrice(),
    };

    if (localStorage.getItem('external_cart_id')) {
      param = {
        ...param,
        ...{ external_cart_id: localStorage.getItem('external_cart_id') },
      };
    }

    params.push(param);

    dispatch(addToCartAction(params))
      .then(() => {
        dispatch(setQuantityToolbar(+quantityValue + +quantityToolbar));
      })
      .finally(() => {
        setAddToCartButtonLoading(false);
      });
  };

  function getPrice() {

    if (consumable.price && typeof consumable.price === 'object') {
      if (consumable.price?.price) {
        return consumable.price.price;
      } else {
        return null;
      }
    }

    return consumable.price;
  }

  function calcLimit() {
    if (typeof consumable.available === 'object' && 'quantity' in consumable.available) {
      return consumable.available?.quantity;
    }

    if (consumable.available && typeof consumable.available === 'object') {
      const newLimit: { uv?: string; warehouse_main } = { ...consumable.available };

      delete newLimit.uv;

      return Object.values(newLimit).reduce((acc, item) => Number(acc) + Number(item?.quantity), 0);
    }

    return consumable.available;
  }

  function getAvailablityTitle() {
    if (consumable?.available?.warehouse_main) {
      const warehouses = { ...consumable.available };

      let totalQuantity = 0;
      let deliveryTime = 0;

      Object.keys(warehouses).forEach((key) => {
        if (key !== 'uv' && warehouses.hasOwnProperty!(key)) {
          totalQuantity += Number(warehouses[key].quantity);

          if (warehouses[key].warehouse_delivery_time) {
            deliveryTime += Number(warehouses[key].warehouse_delivery_time);
          }
        }
      });

      if (quantityValue > Number(warehouses.warehouse_main?.quantity) && quantityValue <= totalQuantity) {
        return `Disponible dans un délai de ${deliveryTime} jours:`;
      }

      if (quantityValue <= Number(warehouses.warehouse_main?.quantity)) {
        return 'Disponible:';
      }

      if (quantityValue <= Number(warehouses.warehouse_main?.quantity)) {
        return 'Disponible:';
      }


      if (!getPrice()) {
        return '';
      }

      return '';
    }

    if (consumable.available?.quantity) {
      if (consumable.available.quantity >= quantityValue) {
        return 'Disponible: ';
      }
    }
  }

  function disableCart() {
    if (currentMarketplace == Marketplaces.RETAILER || currentMarketplace == Marketplaces.PUNCHOUT) {
      if (!calcLimit() && isMecadepotChild) {
        return true;
      }

      if (Number(calcLimit()) < quantityValue && !consumable?.add_to_cart) {
        return true;
      }

      if (!calcLimit() && isMecadepotChild) {
        return true;
      }

      if (addToCartButtonLoading || !quantityValue) {
        return true;
      }

      if (!(calcLimit() && Number(calcLimit()) < quantityValue) && consumable?.add_to_cart) {
        return false;
      }
    }
  }

  function cirrusContactUs() {
    setContactLoading(true);
    const params = {
      source: consumable?.source,
      reference: consumable?.data_supplier_reference_original,
      supplier_id: consumable?.data_supplier?.id,
      product_type: 'consumable'
    };

    http.cirrus
      .contactUs(params)
      .then(() => notify(t('_distributor_contact_soon'), 'success'))
      .catch((err) => notify(err.message))
      .finally(() => setContactLoading(false));
  }

  function contactUsBtn() {
    if (consumable.available && typeof consumable.available.warehouse_main === 'object') {
      if (
        (consumable.available?.warehouse_main.quantity === 0 && consumable.available?.warehouse_all.quantity > 0) ||
        (consumable.available?.warehouse_main.quantity === 0 && consumable.available?.warehouse_all.quantity === 0) ||
        consumable.available?.warehouse_main.quantity === 0 || getPrice()?.price == 0
      ) {
        return (
          <div className="cirrus-contact-us" onClick={cirrusContactUs}>
            {contactLoading ? <Spinner class="extra-small"></Spinner> : t('_contact_us')}
          </div>
        );
      }

      return '';
    }

    return (
      <div className="cirrus-contact-us" onClick={cirrusContactUs}>
        {contactLoading ? <Spinner class="extra-small"></Spinner> : t('_contact_us')}
      </div>
    );
  }

  return (
    <div className="consumable-options-wrapper">
      <div className="top">
        <BarCode item={consumable} />
      </div>

      <div className="availability-add-to-cart-wrapper">
        <div className="bottom">
          <div className="availability">
            {currentMarketplace == Marketplaces.RETAILER || currentMarketplace == Marketplaces.PUNCHOUT ? (
              calcLimit() ? (
                consumable.add_to_cart && (
                  <QuantityInput uv={Number(consumable?.available?.uv)} setValue={setQuantityValue} value={quantityValue} />
                )
              ) : !calcLimit() && consumable.add_to_cart ? (
                <QuantityInput uv={Number(consumable?.available?.uv)} setValue={setQuantityValue} value={quantityValue} />
              ) : null
            ) : (
              consumable.add_to_cart && <QuantityInput setValue={setQuantityValue} value={quantityValue} />
            )}
            {user?.numcli === Number(process.env.REACT_APP_CIRRUS_NUMCLI) ? (
              <CirrusDisponibility setDisableCartBtn={setDisableCartBtn} loading={false} value={quantityValue} data={consumable} setIsInternalclient={setIsInternalclient} />
            ) : (
              <Disponibility
                loading={false}
                value={quantityValue}
                limit={consumable?.available}
                title={getAvailablityTitle()}
                price={consumable.price}
              />
            )}
            <CarPartPrice loading={false} currency={currencies.EUR} price={consumable?.price} priceVAT={consumable?.price?.price_with_vat} quantityValue={quantityValue} />
          </div>
          {isMobile ? (
            <div className="mobile-buttons">
              <div className="add-to-quote-button">
                <IconButton
                  text={t('_add_to_quote')}
                  className="iconButton"
                  icon={<FontAwesomeIcon icon={faFileLines} className="add-to-quote" />}
                ></IconButton>
              </div>
              {user?.numcli === Number(process.env.REACT_APP_CIRRUS_NUMCLI) && contactUsBtn() && !isInternalclient ? (
                contactUsBtn()
              ) : (
                consumable?.add_to_cart && (
                  <div className="add-to-cart-button">
                    <IconButton
                      text={t('_add_to_cart')}
                      disabled={disableCart()}
                      className="iconButton"
                      onClick={handleAddToCart}
                      icon={
                        addToCartButtonLoading ? <Spinner class="extra-small"></Spinner> : <FontAwesomeIcon icon={faCartShopping} className="" />
                      }
                    ></IconButton>
                  </div>
                ))}
            </div>
          ) : (
            user?.numcli === Number(process.env.REACT_APP_CIRRUS_NUMCLI) && contactUsBtn() && !isInternalclient ? (
              contactUsBtn()
            ) : (
              consumable?.add_to_cart && (
                <div className="button">
                  <IconButton
                    text={t('_add_to_cart')}
                    disabled={disableCart()}
                    className="iconButton"
                    onClick={handleAddToCart}
                    icon={
                      addToCartButtonLoading ? <Spinner class="extra-small"></Spinner> : <FontAwesomeIcon icon={faCartShopping} className="" />
                    }
                  ></IconButton>
                </div>
              ))
          )}
        </div>
      </div>

    </div>
  );
};

ConsumableOptions.displayName = 'ConsumableOptions';

export default ConsumableOptions;
